import React, { useMemo } from 'react';
import {
  Box,
  Field,
  FieldTypes,
  Inscription,
} from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';

import MultipleOrganizationSelector, { OrganizationName } from '../../AddClaimProcessorAndTeamButton/MultipleOrganizationSelector';
import { ClaimsTeam } from '../../ClaimsProcessors.types';
import { MultipleServiceSelector } from '../MultipleServiceSelector';
import { Service } from '../MultipleServiceSelector/useGetAllServices.query';


interface Props {
  setOrganizationsNames: (value: OrganizationName[]) => void;
  editableTeam?: ClaimsTeam;
  setServicesIds: (value: string[]) => void;
  servicesIds: string[];
  isSubmit: boolean;
  allServices?: Service[];
}

export const useCreateClaimsTeamFields = (props: Props) => {
  const {
    setOrganizationsNames,
    editableTeam,
    setServicesIds,
    servicesIds,
    isSubmit,
    allServices,
  } = props;

  const fields: Field[] = useMemo(() => [
    {
      name: 'teamName',
      type: FieldTypes.Text,
      showRequireIcon: true,
      label: 'Team name',
      placeholder: 'Team name',
      defaultValue: editableTeam?.name || '',
      validator: yup.string().required(REQUIRED_TEXT),
    },
    {
      name: 'assignmentToOrganization',
      placeholder: 'None',
      type: FieldTypes.Node,
      label: (
        <Box margin={{ top: 'spacing8' }} direction="row" data-testId="organization_label">
          <Inscription
            color="danger"
            margin={{
              right: '3px',
              top: '1px',
            }}
          >
            *
          </Inscription>
          <Inscription>Assignment to organization</Inscription>
        </Box>
      ),
      value: (
        <MultipleOrganizationSelector
          currentTeamId={editableTeam?.id}
          onChange={setOrganizationsNames}
          currentOrganizations={editableTeam?.assignedOrganizations}
          isSubmit={isSubmit}
        />),
      // @ts-ignore
      isNarrowLabelMode: true,
    },
    {
      name: 'services',
      type: FieldTypes.Node,
      label: (
        <Box margin={{ top: 'spacing8' }} direction="row" data-testId="services_label">
          <Inscription
            color="danger"
            margin={{
              right: '3px',
              top: '1px',
            }}
          >
            *
          </Inscription>
          <Inscription>Services</Inscription>
        </Box>
      ),
      placeholder: 'None',
      value: (
        <MultipleServiceSelector
          appliedServicesIds={servicesIds}
          applyServicesIds={setServicesIds}
          isSubmit={isSubmit}
          isGenericClaimsTeam={editableTeam?.isGenericClaimsTeam}
          allServices={allServices}
        />
      ),
    },
  ], [allServices, editableTeam, setOrganizationsNames, setServicesIds, servicesIds, isSubmit]);

  return fields;
};
